import { render, staticRenderFns } from "./InitioFormulateBase.vue?vue&type=template&id=7c1b1e94&scoped=true&"
import script from "./InitioFormulateBase.vue?vue&type=script&lang=js&"
export * from "./InitioFormulateBase.vue?vue&type=script&lang=js&"
import style0 from "./InitioFormulateBase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InitioFormulateBase.vue?vue&type=style&index=1&id=7c1b1e94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b1e94",
  null
  
)

export default component.exports